import React, { memo } from 'react';
import PropTypes from 'prop-types';

const SideNavigation = ({ children }) => {
  return <div className="sidenav-container">{children}</div>;
};

SideNavigation.propTypes = {
  children: PropTypes.array,
};

export default memo(SideNavigation);
